<template>
  <div class="project_info_data d_flex flex_direction_col fz12 c_1A1A1A">
    <div class="notice-w">
      <div class="problem_head d_flex justify_content_sb">
        <span class="problem_node_title font_w_bold">{{
          cmsProblemNodeValue()
        }}</span>
      </div>
      <div
        class="problem_list"
        :style="{ height: isShowBidList ? '127px' : '304px' }"
      >
        <ul>
          <li
            v-for="item in cmsProblemNode.children"
            :key="item.id"
            class="link-item text_ellipsis"
          >
            <router-link
              :to="`${item.nodeModel.route}/${item.id}`"
              :title="item.name"
              >{{ item.name }}</router-link
            >
          </li>
        </ul>

        <Emtry v-if="!cmsProblemNode.children.length" />
      </div>
    </div>

    <div v-if="isAuction" class="new_bid_w d_flex flex_direction_col">
      <div class="font_w_bold record_title">最新出价</div>
      <div class="record_list flex_1">
        <ul>
          <li
            v-for="(item, index) in itemDetail.biddings.slice(0, 3)"
            :key="item.id"
          >
            <p class="d_flex">
              <span v-if="index === 0" class="flex_1">{{
                itemDetail.state === 9 ? "成交" : "领先"
              }}</span>
              <span v-else class="flex_1">出局</span>
              <span class="flex_1" style="display: flex">
                <div>{{ item.phone }}</div>
                <span v-if="item.priority"
                  ><img
                    src="@/assets/images/you.png"
                    style="
                      height: 17px;
                      position: relative;
                      top: -2px;
                      right: -3px;
                      margin-right: 5px;
                    "
                /></span>
                <span v-if="item.principal"
                  ><img
                    src="@/assets/images/wei.png"
                    style="
                      height: 18px;
                      position: relative;
                      top: -2px;
                      right: -3px;
                    "
                /></span>
              </span>
              <span class="flex_1 text_right"
                >￥{{ numTranFloat(item.bidPrice) }}</span
              >
            </p>
            <p class="c_808080">{{ item.createdAt }}</p>
          </li>
        </ul>

        <Emtry v-if="itemDetail.biddings && !itemDetail.biddings.length" />
      </div>
    </div>
  </div>
</template>

<script>
import { regMobile, numTranFloat, findItemByArr } from "@/utils";
import { mapGetters, mapActions } from "vuex";
import { TradeMode } from "@/enums";
import SeamlessScroll from "@/components/base/SeamlessScroll.vue";
import Emtry from "@/components/base/Emtry.vue";

export default {
  components: {
    SeamlessScroll,
    Emtry,
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["siteInfo", "cmsProblemNode"]),

    numTranFloat() {
      return function (num) {
        return numTranFloat(num);
      };
    },

    isAuction() {
      return TradeMode.AUCTION === this.itemDetail.project.tradeMode;
    },
    // 公告节点
    noticeColumn() {
      return findItemByArr(this.siteInfo.nodes, "code", "problem");
    },
    isShowBidList() {
      return [TradeMode.AUCTION].includes(this.itemDetail.project.tradeMode);
    },
  },
  created() {
    setTimeout(() => {
      this.initProblemNode();
    }, 0);
  },
  methods: {
    ...mapActions({
      initProblemNode: "cache/initProblemNode",
    }),
    cmsProblemNodeValue() {
      return this.cmsProblemNode.name;
    },
  },
};
</script>

<style lang='scss' scoped>
.project_info_data {
  width: 318px;
  border: 1px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  .notice-w {
    flex: 1;
  }
  .new_bid_w {
    flex: 1;
  }
  .problem_head {
    padding: 10px 10px 0 20px;
    border-bottom: 1px solid #e6e6e6;
  }
  .problem_list {
    overflow-x: hidden;
    overflow-y: scroll;
    margin: 6px 0;
    padding: 0 20px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e6e6e6;
    }
    .link-item {
      padding: 10px 0;
      border-bottom: 1px solid #e6e6e6;
      font-size: 12px;
      &:last-child {
        border: 0;
      }
    }
  }
  .record_title {
    padding: 9px 19px 8px 19px;
    background-color: #e5eef6;
  }
  .record_list {
    padding: 0 20px;
    & li {
      padding: 10px 0 6px 0;
      border-bottom: 1px solid #e6e6e6;
      &:last-child {
        border: 0;
      }
      p {
        &:first-child {
          margin: 0 0 5px 0;
        }
      }
    }
  }

  .problem_node_title {
    padding: 0 0 6px 0;
    border-bottom: 2px solid #0983cc;
  }
}
</style>
